import BarChart from "./BarChart";

export {BarChart}
export default BarChart
